import React from "react";
import { FilterState, FilterKey, FilterKeys } from "../types";
import UserFilter from "./UserFilter";
import ResourceTypeFilter from "./ResourceTypeFilter";
import ActionFilter from "./ActionFilter";
import DateFilter from "./DateFilter";
import useGetLanguage from "../../../../utils/useGetLanguage";
import { LanguageText } from "../../../../dictionary/GroupsText";
interface FilterBarProps {
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  groupId: string;
  uniqueUserIds: string[];
  onUserSelect?: (userId: string, userEmail: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  filters,
  onFiltersChange,
  onApplyFilters,
  onClearFilters,
  groupId,
  uniqueUserIds,
  onUserSelect,
}) => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });

  const handleFilterChange = (key: FilterKey, value: any) => {
    onFiltersChange({
      ...filters,
      [key]: value,
    });
  };

  const hasActiveFilters = () => {
    return (
      filters.user ||
      filters.resourceType ||
      filters.action ||
      (filters.dateRange.start && filters.dateRange.end)
    );
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <UserFilter
          value={filters.user}
          onChange={(value) => handleFilterChange(FilterKeys.User, value)}
          groupId={groupId}
          uniqueUserIds={uniqueUserIds}
          onUserSelect={onUserSelect}
        />
        <ResourceTypeFilter
          value={filters.resourceType}
          onChange={(value) => handleFilterChange(FilterKeys.ResourceType, value)}
        />
        <ActionFilter
          value={filters.action}
          onChange={(value) => handleFilterChange(FilterKeys.Action, value)}
        />
        <DateFilter
          value={filters.dateRange}
          onChange={(value) => handleFilterChange(FilterKeys.DateRange, value)}
        />
      </div>
      <div className="flex justify-end items-center space-x-3">
        <button
          onClick={onClearFilters}
          className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors"
        >
          <svg
            className="w-4 h-4 mr-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
          {Language?.groupAuditLogs?.clear}
        </button>
        <button
          onClick={onApplyFilters}
          disabled={!hasActiveFilters()}
          className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {Language?.groupAuditLogs?.applyfilter}
        </button>
      </div>
    </div>
  );
};

export default FilterBar;
